import { Loading } from 'element-ui'

export default function () {
  return Loading.service()
}
